import { collection, onSnapshot, query, where } from "firebase/firestore";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import notifData from "../animations/empty-notifications.json";
import BottomNav from "../components/BottomNav";
import { auth, db } from "../functions/firebase";
import "./notif.css";

export default function Notifications() {

    const navigate = useNavigate()

    const [history, setHistory] = useState([]) 

    useEffect(() => {

        return onSnapshot(
            query(collection(db, "orders"), 
            where("user", "==", auth.currentUser?.uid)
        ), {
            next: async d => {

                setHistory(d.docs.map(c => ({ ...c.data().data, id: c.id })))
            },
            error: () => null
        })

    }, [])

    return (
        <>
            <p style={{ color: "var(--primary)", margin: "20px 0", fontSize: 17, textAlign: "center" }}>Active Orders</p>
            {history.length === 0 && (
                <>
                    <Lottie 
                        animationData={notifData}
                        style={{ width: "70vw", margin: "20px auto", marginBottom: 0 }}
                    />
                </>
            )}
            <div id="notifications-wrapper">
                {history.map(order => (
                    <div key={order?.id} className="cartItem" > 
                        <div>
                            <p style={{ color: "grey", fontWeight: "bold", textTransform: "capitalize", textAlign: "center", fontSize: 25, marginBottom: 20 }}>Status: {order.status === "orderready" ? "Preparing" : order.status}</p>
                            <p style={{ color: "#000", fontSize: 12 }}>Your Order</p>
                            {order?.items?.map(c => (
                                <p key={c.id} style={{ color: "#000", marginBottom: 10 }}>
                                    {c.quantity + " x " + c.title}<br /><span style={{ color: "red", fontSize: 14 }}>
                                    {c.sources.join(", ")}
                                    </span>
                                </p>
                            ))}
                            <div style={{ backgroundColor: "#FFF", color: "#000", borderRadius: 10, padding: "15px 0px", borderWidth: 1, borderColor: "rgb(209, 209, 209)" }}>
                                <p style={{ color: "#000", fontSize: 12 }}>On Checkout</p>
                                <div className="row spaceBetween">
                                    <p>Order Type</p>
                                    <p style={{ fontWeight: "bold" }}>{order.type === "collect" ? "Collection" : "Delivery"}</p>
                                </div>
                                <br/>
                                <div className="row spaceBetween">
                                    <p>Payment Method</p>
                                    <p style={{ fontWeight: "bold", textTransform: "capitalize" }}>{order.payment === "speedpoint" ? "Card/Swipe" : order.payment}</p>
                                </div>
                                <br/>
                                <p style={{ color: "#000", fontSize: 12 }}>Payment Info</p>
                                <div className="row spaceBetween">
                                    <p>Cart Total</p>
                                    <p style={{ fontWeight: "bold" }}>R{(order.total).toFixed(2)}</p>
                                </div>
                                <br/>
                                {order.type === "delivery"  && (
                                    <>
                                        <div className="row spaceBetween">
                                            <p>Delivery Fee</p>
                                            <p style={{ fontWeight: "bold" }}>R{order.deliveryCharge?.toFixed(2)}</p>
                                        </div>
                                        <br/>
                                    </>
                                )}
                                <div className="row spaceBetween">
                                    <p>Service Fee</p>
                                    <p style={{ fontWeight: "bold" }}>R2.00</p>
                                </div>
                                <br/>
                                <div className="row spaceBetween">
                                    <p>Your order total</p>
                                    <p style={{ fontWeight: "bold" }}>R{(order.total).toFixed(2)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
              
            </div>
            {window.innerWidth < 480 && <div style={{ height: 180, width: 20 }} />}
            <BottomNav bell />
        </>
    )
}